import axios, { AxiosInstance } from 'axios';
import { apiConfig } from '@/config/apiConfig';
import { getVoiceFallbackClient } from './_shared';

// ── Voice definitions (/api/agents/voices) ──────────────────────────

export type VoiceDefinition = {
  name: string;
  gender: string;
  style: string;
  accent: string;
  voice_id: string;
};

export async function fetchVoices(axiosInstance?: AxiosInstance, language?: string): Promise<VoiceDefinition[]>;
export async function fetchVoices(language?: string, axiosInstance?: AxiosInstance): Promise<VoiceDefinition[]>;
export async function fetchVoices(
  arg1?: string | AxiosInstance,
  arg2?: string | AxiosInstance
): Promise<VoiceDefinition[]> {
  let language: string | undefined;
  let client: AxiosInstance | undefined;

  if (typeof arg1 === 'string') {
    language = arg1;
    if (typeof arg2 !== 'string') client = arg2;
  } else if (arg1 && typeof arg1 === 'object') {
    client = arg1 as AxiosInstance;
    if (typeof arg2 === 'string') language = arg2;
  } else if (typeof arg2 === 'string') {
    language = arg2;
  } else if (arg2 && typeof arg2 === 'object') {
    client = arg2 as AxiosInstance;
  }

  const finalClient = client || getVoiceFallbackClient();
  const url = apiConfig.voiceEndpoints.voices;
  const response = await finalClient.get<VoiceDefinition[]>(url, { params: language ? { language } : {} });
  return response.data || [];
}
